import {GET_SUB_INFO} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case GET_SUB_INFO:
            return action.payload;
        default:
            return state;
    }
};